import { useMemo, useState } from "react";
import CustomSelect from "../../CommonComponents/CustomSelect";
import { Dropdown } from "react-bootstrap";
import { BUS_COMPONENTS_TYPES } from "../utils/constants";
import { getSelectedValue, handleExportTemplate } from "../utils";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { MissionStore } from "../../../store/MissionSlice";
import CustomToolTip from "../../CommonComponents/CustomToolTip";

interface BusComponentsProps {
  allBusComponents: any[];
  setDeleteCatalouge: (catalogue: any) => void;
  onEdit: (catalog: any, catalogId: string) => void;
  onClone: (catalog: any, catalogId: string) => void;
}

const BusComponents = ({ allBusComponents, setDeleteCatalouge, onEdit, onClone }: BusComponentsProps) => {

  const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);
  const [selectedCatalogueType, setSelectedCatalogueType] = useState<string | null>(null);

  const handleCatalogueTypesChange = (selectedOption) => {
    setSelectedCatalogueType(selectedOption?.value || null);
  };

  const filteredComponents = useMemo(() => selectedCatalogueType ? allBusComponents.filter((comp) => comp["catalogue-type"] === selectedCatalogueType) : allBusComponents || [], [selectedCatalogueType, allBusComponents]);

  const reset_filter = () => {
    setSelectedCatalogueType(null);
  }

  return (
    <div className='d-flex flex-wrap w-100 flex-1'>
      <div className='w-20 bg-transparent border-right px-2 py-3 d-flex flex-column justify-content-between'>
        <div className='d-flex flex-column gap-2'>
          <span className="">Bus Components</span>
          <CustomSelect
            placeholder="Select Bus Component"
            options={BUS_COMPONENTS_TYPES}
            value={getSelectedValue(selectedCatalogueType)}
            onChange={handleCatalogueTypesChange}
          />
        </div>
        <div className="d-flex justify-content-center">
          <button className='btn btn-outline-primary w-80 fs-18' onClick={reset_filter}>Reset</button>
        </div>
      </div>
      <span className='border-left-3 h-100'></span>
      <div className="w-80 d-flex flex-column flex-1 pop-scroll-3xl py-5 ps-3 gap-4">
        <div className="catalog__cards__grid__container">
          {filteredComponents.map((data) => {
            if (selectedCatalogueType && selectedCatalogueType !== data?.["catalogue-type"]) return null;
            return (
              <div className="catalog__card__container" key={data?.["uniqueId"]}>
                <div className="catalog__card__header">
                  <div className="d-flex flex-column">
                    <span className="card__text__container card__header_title">
                      <CustomToolTip title={data?.["name"]}>
                        {data?.["name"]}
                      </CustomToolTip>
                    </span>
                    <span className="card__text__container">{data?.['catalogue-type']}</span>
                  </div>
                  <div className="card__icon__container">
                    <Dropdown drop={"end"}>
                      <Dropdown.Toggle variant="transparent text-white fs-20">
                        <i className="fe fe-more-vertical"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {userData?.['feature-allowed']?.['Catalogue'] === 'Yes' &&
                          <Dropdown.Item
                            eventKey="0"
                            onClick={() => {
                              handleExportTemplate(data, `${data?.['name']}-component.json`);
                            }}
                          >
                            Export
                          </Dropdown.Item>
                        }
                        {data?.['owner-org'] === userData?.['owner_org'] &&
                          <Dropdown.Item
                            eventKey="1"
                            onClick={() => {
                              onEdit(data, data?.['uniqueId']);
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                        }
                        <Dropdown.Item
                          eventKey="2"
                          onClick={() => {
                            onClone(data, data?.['uniqueId']);
                          }}
                        >
                          Clone
                        </Dropdown.Item>
                        {data?.['owner-org'] === userData?.['owner_org'] &&
                          <Dropdown.Item
                            eventKey="3"
                            onClick={() => {
                              setDeleteCatalouge(data);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="catalog__card__body">
                  {!isEmpty(data['product-cookie']) && Object.entries(data['product-cookie']).map(([key, value], idx) => {
                    if (idx > 4) return null;
                    return (
                      <div className="card__body__text__container" key={idx}>
                        <span className="card__text__container card__body_title">
                          <CustomToolTip title={`${value}`}>
                            {`${value}`}
                          </CustomToolTip>
                        </span>
                        <span className="card__text__container card__body__subtitle">{key}</span>
                      </div>
                    )
                  })}
                  {data['max_power_consumption_in_watts'] &&
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data['max_power_consumption_in_watts'] + ' W'}>
                          {data['max_power_consumption_in_watts'] + ' W'}
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">Peak Power</span>
                    </div>
                  }
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

export default BusComponents;